import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { Container, ErrorMessage, PageHeader } from '../../common';
import PrimaryCaregiverForm from './PrimaryCaregiverForm';
import PrimaryCaregiverDetails from './PrimaryCaregiverDetails';

import {
  allDoctorsSelector,
  homeAddressesSelector,
  notificationSettingsSelector,
  notificationTemplatesSelector,
  pharmaciesSelector,
} from '../../../lib/dataLayer';

import {
  getGeofences,
  meetsUserSettings,
} from '../../Geolocation/geofenceHelpers';

import withGeolocation, { GEO_DEBUG } from '../../Geolocation';

const Error = styled(ErrorMessage)`
  margin-bottom: 10px;
`;

const mapStateToProps = state => {
  // puts grabs the data from store
  // we must call the thunks before we reach this component or onMount
  // in this case we call them in onMount from the PrimaryCaregiverPageContainer.js file
  const doctors = allDoctorsSelector(state);
  const homeAddressesORIGINAL = homeAddressesSelector(state);
  const pharmaciesORIGINAL = pharmaciesSelector(state);
  const notificationSettings = notificationSettingsSelector(state);
  const notificationTemplates = notificationTemplatesSelector(state);

  const geofences = getGeofences({
    frequencyNotificationTemplates: notificationTemplates,
    doctors,
    homeAddresses: homeAddressesORIGINAL,
    pharmacies: pharmaciesORIGINAL,
  });

  if (GEO_DEBUG) {
    console.log('========[ mapStateToProps(): START ]========');
    console.log();
    console.log('doctors:');
    console.log(doctors);
    console.log();
    console.log('homeAddressesORIGINAL:');
    console.log(homeAddressesORIGINAL);
    console.log();
    console.log('pharmaciesORIGINAL:');
    console.log(pharmaciesORIGINAL);
    console.log();
    console.log('notificationSettings:');
    console.log(notificationSettings);
    console.log();
    console.log('notificationTemplates:');
    console.log(notificationTemplates);
    console.log();
    console.log('geofences:');
    console.log(geofences);
    console.log();
    console.log('========[ mapStateToProps(): END ]========');
  }

  return {
    geofences,
  };
};

class PrimaryCaregiverPage extends React.Component {
  state = {
    isEditing: false,
    loadingError: '',
  };

  componentDidMount() {
    this.props.onMount().catch(error => this.setState({ loadingError: error }));
  }

  handleEdit = () => {
    this.setState({
      isEditing: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isEditing: false,
    });
  };

  render() {
    const { isLoading, onContinue, onSave, primaryCaregiver } = this.props;
    const { isEditing, loadingError } = this.state;
    const shouldShowForm = isEmpty(primaryCaregiver.firstName) || isEditing;
    return (
      <Container>
        <PageHeader
          onEdit={this.handleEdit}
          shouldShowEdit={!shouldShowForm}
          title="Primary Caregiver"
        />
        {!!loadingError && <Error>{loadingError}</Error>}
        {!!isLoading && isEmpty(primaryCaregiver.firstName) ? (
          <div>Loading...</div>
        ) : shouldShowForm ? (
          <PrimaryCaregiverForm
            {...primaryCaregiver}
            isEditing={isEditing}
            onCancel={this.handleCancel}
            onContinue={onContinue}
            onSave={onSave}
          />
        ) : (
          <PrimaryCaregiverDetails {...primaryCaregiver} />
        )}
      </Container>
    );
  }
}

PrimaryCaregiverPage.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onMount: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  primaryCaregiver: PropTypes.object,
};

export default connect(
  mapStateToProps,
  () => {},
)(withGeolocation(PrimaryCaregiverPage));



// WEBPACK FOOTER //
// ./src/modules/PrimaryCaregiverPage/components/PrimaryCaregiverPage.js